// ** Third Party Components
import styled, { css } from "styled-components";

// #####################################################

export const ControlButton = styled("button").attrs({
	role: "button",
})`
	margin: 0.5rem 0 0.5rem 0;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: ${({ theme: { borderRadius } }) => borderRadius.card};
	height: 35px;
	width: 38px;
	padding: 0 0.6rem;
	background-color: rgba(0, 0, 0, 0.3);
	${({ customMargin }) => {
		if (customMargin) {
			return css`
				margin: ${customMargin};
			`;
		}
	}}

	${({ width }) => {
		if (width) {
			return css`
				width: ${width};
			`;
		}
	}}

	${({ disabled }) =>
		disabled &&
		css`
			> * {
				opacity: 0.6;
				cursor: pointer;
			}
		`}
`;

// #####################################################
